<style>
#side {
    width: 60%;
    background-color: white;
    line-height: 1.5em;
    font-size: 14px;
    max-height: 100%;
    overflow: scroll;
    word-wrap: anywhere;
    box-shadow: 0px 0px 5px lightgrey;
    z-index: 1;
    padding: 20px;
}

@keyframes example {
    from {width: 0%;}
    to {width:50%;}
}

@media (max-width:972px) {
    #side {
        width: calc(100% - 20px);
        flex: 1;
        border: none;
        padding: 10px;
        box-shadow: none;
    }

    .no-map {
        padding-top: 0px !important;
    }
}
</style>

<script>
import {onMount, afterUpdate} from 'svelte'
import * as Common from './Common.js'
import ItemView from './ItemView.svelte';
import AddItemView from './AddItemView.svelte';
import LoginView from './LoginView.svelte';
import UserView from './UserView.svelte';
import UserManagementView from './UserManagementView.svelte';
import WelcomeView from './WelcomeView.svelte';
import InboxView from './InboxView.svelte';
import AreaView from './AreaView.svelte';
import GuidelinesView from './GuidelinesView.svelte'
import FeedbackView from './FeedbackView.svelte'
import ForgotPasswordView from './ForgotPasswordView.svelte'
import ResetPasswordView from './ResetPasswordView.svelte'
import CommentView from './CommentView.svelte'
import AreasView from './AreasView.svelte'
import AboutView from './AboutView.svelte'
import TagView from './TagView.svelte'
import RemoveEmailSubscriptionView from './RemoveEmailSubscriptionView.svelte'

import AreaAdmin from './MunicipalTools/AreaAdmin.svelte'

import Spinner from './Spinner.svelte'

export let stage;
export let items;
export let showMapOnMobile;

let side;
let scrollPos = {}

onMount(async () => {
    side.onscroll = () => {
        scrollPos[window.location.href] = side.scrollTop
    }
})

function appendAddedItem(item) {
    items = items.concat(item)
}

function removeItemWithId(itemId) {
    items = items.filter(n => n.item_id != itemId)
}

afterUpdate(async () => {
    if(stage.page != "welcome" && stage.page != "area" && stage.page != "user" && stage.page != "tag") {
        side.scrollTop = 0;
    }
})

</script>

{#if stage}
    <div id="side" bind:this={side} class={(!Common.isMobile() || showMapOnMobile) ? '' : 'no-map'}>
        <div id="holder">
            {#if stage.page === "spinner"}
                <Spinner></Spinner>
            {:else if stage.page === "item"}
                <ItemView {removeItemWithId} item={stage.item} ></ItemView>
            {:else if stage.page === "add-item"}
                <AddItemView {appendAddedItem} bind:itemType={stage.type} itemLocation={stage.itemLocation}></AddItemView>
            {:else if stage.page === "login"}
                <LoginView message={""}></LoginView>
            {:else if stage.page === "user"}
                <UserView bind:side={side} user={stage.user}></UserView>
            {:else if stage.page === "account"}
                <UserManagementView></UserManagementView>    
            {:else if stage.page === "welcome"}
                <WelcomeView bind:side={side}></WelcomeView>
            {:else if stage.page === "inbox"}
                <InboxView></InboxView>
            {:else if stage.page === "area"}
                <AreaView bind:side={side} area={stage.area}></AreaView>
            {:else if stage.page === "policies"}
                <GuidelinesView></GuidelinesView>
            {:else if stage.page === "contact"}
                <FeedbackView></FeedbackView>
            {:else if stage.page === "forgot-password"}
                <ForgotPasswordView></ForgotPasswordView>
            {:else if stage.page === "reset-password"}
                <ResetPasswordView code={stage.code}></ResetPasswordView>
            {:else if stage.page === "comment"}
                <CommentView comment={stage.comment}></CommentView>
            {:else if stage.page === "areas"}
                <AreasView></AreasView>
            {:else if stage.page === "about"}
                <AboutView></AboutView>
            {:else if stage.page === "areaadmin"}
                <AreaAdmin area={stage.area}></AreaAdmin>
            {:else if stage.page === "tag"}
                <TagView bind:side={side} selectedAreaID={stage.area_id} tag={stage.tag}></TagView>
            {:else if stage.page === "unsubscribe"}
                <RemoveEmailSubscriptionView></RemoveEmailSubscriptionView>
            {:else if stage.page === "none"}
                <i>Content does not exist or is unavailable.</i><br><a href="#/">Go Home</a>
            {/if}
        </div>
    </div>
{/if}